import React, { useEffect, useState } from 'react';
import { fetchStats } from '../api/whatsappTasksApi';
import { StatusDonut, SkeletonBlock, EmptyState } from '../../../components/module-ui';
import { Tray } from '@phosphor-icons/react';

function StatCard({ label, value, color }) {
  return (
    <div style={{ padding: '10px', background: '#F9FAFB', borderRadius: '8px', border: '1px solid #E5E7EB' }}>
      <div style={{ fontSize: '12px', color: '#6B7280' }}>{label}</div>
      <div style={{ fontSize: '15px', fontWeight: '700', color }}>{value}</div>
    </div>
  );
}

function OverviewPage({ refreshKey }) {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    fetchStats()
      .then(setStats)
      .catch((e) => setError(e.response?.data?.detail || 'Failed to load overview'))
      .finally(() => setLoading(false));
  }, [refreshKey]);

  if (loading) return <SkeletonBlock rows={4} />;
  if (error) return <p style={{ color: '#B91C1C' }}>{error}</p>;
  if (!stats) {
    return <EmptyState icon={Tray} title="No WhatsApp stats" description="Connect WhatsApp and refresh to see activity." />;
  }

  const statusMix = {
    open: stats.new_count || 0,
    in_progress: stats.in_progress_count || 0,
    completed: stats.done_today_count || 0,
    pending: stats.overdue_count || 0,
  };

  return (
    <div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(140px, 1fr))', gap: '8px', marginBottom: '16px' }}>
        <StatCard label="New Tickets" value={stats.new_count} color="#2563EB" />
        <StatCard label="In Progress" value={stats.in_progress_count} color="#D97706" />
        <StatCard label="Overdue" value={stats.overdue_count} color="#B91C1C" />
        <StatCard label="Done Today" value={stats.done_today_count} color="#059669" />
      </div>
      <div className="wd-chart-grid">
        <StatusDonut data={statusMix} title="Ticket mix" />
      </div>
    </div>
  );
}

export default OverviewPage;
